import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  showTagline?: boolean;
  tagline?: string;
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
  showText = true,
  showTagline = true,
  tagline = 'By Hutech Solutions'
}) => {
  const sizeMap = {
    sm: { img: 'h-7 w-7', text: 'text-base', sub: 'text-[9px]' },
    md: { img: 'h-9 w-9', text: 'text-lg', sub: 'text-[10px]' },
    lg: { img: 'h-12 w-12', text: 'text-2xl', sub: 'text-xs' },
    xl: { img: 'h-16 w-16', text: 'text-3xl', sub: 'text-sm' },
  };

  const currentSize = sizeMap[size];

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      <img
        src="/logo.png"
        alt="Sahaj Connect Logo"
        className={`${currentSize.img} object-contain rounded-xl shadow-xs transition-transform hover:scale-105`}
      />
      {showText && (
        <div className="flex flex-col leading-tight text-left">
          <span className={`font-black tracking-tight text-foreground ${currentSize.text}`}>
            Sahaj<span className="text-primary font-extrabold">Connect</span>
          </span>
          {showTagline && (
            <span className={`text-[#1a1b4b] dark:text-indigo-300 font-bold tracking-normal ${currentSize.sub}`}>
              {tagline}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
